const styles = [
  {
    name: "Select",
    class: "select",
    type: "select",
    id: "Select",
  },
  {
    class: "scaling-tool",
    type: "select",
    tool: "ScalingTool",
    id: "ScalingTool",
  },
  {
    name: "Select Group",
    class: "select-group",
    type: "select",
    id: "SelectGroup",
  },
  {
    name: "Re-shape",
    class: "re-shape",
    type: "select",
    id: "Reshape",
    requiredFeature: "EditModeEnabled",
  },
  {
    name: "Select Results",
    class: "select-results",
    type: "select",
    id: "SelectResults",
    requiredFeature: "AssessmentResultsPopupEnabled",
  },
  {
    name: "Split",
    class: "editCable",
    type: "select",
    id: "SplitCable",
  },
  {
    name: "Delete",
    class: "delete",
    type: "delete",
    id: "Delete",
  },
  {
    name: "Delete Group",
    class: "delete-group",
    type: "delete",
    id: "DeleteGroup",
  },
  {
    name: "Ground-mounted Transformer",
    class: "substation-gmt",
    type: "transformer",
    tool: "Marker",
    circleMarker: true,
    borderColor: "transparent",
    size: 3,
    id: "GroundMountedTransformer",
    layerType: "marker",
  },
  {
    name: "Pole-mounted Transformer",
    class: "substation-pmt",
    type: "transformer",
    tool: "Marker",
    circleMarker: true,
    borderColor: "transparent",
    size: 3,
    id: "PoleMountedTransformer",
    layerType: "marker",
  },
  {
    name: "Underground Cable",
    class: "underground-cable",
    type: "cable",
    tool: "Line",
    weight: "3",
    color: "rgb(52, 58, 64)",
    id: "UndergroundCable",
    layerType: "polyline",
  },
  {
    name: "Overhead Line",
    class: "overhead-line",
    type: "cable",
    tool: "Line",
    weight: "6",
    color: "rgb(52, 58, 64)",
    id: "OverheadLine",
    layerType: "polyline",
  },
  {
    name: "Node",
    class: "node",
    type: "groupedConnection",
    tool: "Marker",
    circleMarker: false,
    borderColor: "transparent",
    size: 3,
    id: "Node",
    layerType: "marker",
  },
  {
    name: "Domestic Property",
    class: "domestic",
    type: "connectionPoint",
    tool: "Marker",
    circleMarker: true,
    borderColor: "transparent",
    size: 3,
    id: "DomesticProperty",
    layerType: "marker",
  },
  {
    name: "Small Commercial Property",
    class: "small-commercial",
    type: "connectionPoint",
    tool: "Marker",
    circleMarker: true,
    borderColor: "transparent",
    size: 3,
    id: "SmallCommercialProperty",
    layerType: "marker",
  },
  {
    name: "Large Commercial Property",
    class: "large-commercial",
    type: "connectionPoint",
    tool: "Marker",
    circleMarker: true,
    borderColor: "transparent",
    size: 3,
    id: "LargeCommercialProperty",
    layerType: "marker",
  },
  {
    name: "Industrial Property",
    class: "industrial",
    type: "connectionPoint",
    tool: "Marker",
    circleMarker: true,
    borderColor: "transparent",
    size: 3,
    id: "IndustrialProperty",
    layerType: "marker",
  },
  {
    name: "Generator",
    class: "generator",
    type: "connectionPoint",
    tool: "Marker",
    circleMarker: true,
    borderColor: "transparent",
    size: 3,
    id: "Generator",
    layerType: "marker",
  },
  {
    name: "Welder",
    class: "welder",
    type: "connectionPoint",
    tool: "Marker",
    circleMarker: true,
    borderColor: "transparent",
    size: 3,
    id: "Welder",
    layerType: "marker",
  },
  {
    name: "Motor",
    class: "motor",
    type: "connectionPoint",
    tool: "Marker",
    circleMarker: true,
    borderColor: "transparent",
    size: 3,
    id: "Motor",
    layerType: "marker",
  },
  {
    name: "EV Chargepoint",
    class: "evChargePoint",
    type: "connectionPoint",
    tool: "Marker",
    circleMarker: true,
    borderColor: "transparent",
    size: 3,
    id: "EvChargePoint",
    layerType: "marker",
  },
  {
    name: "Grouped Connection",
    class: "connection",
    type: "groupedConnection",
    tool: "Marker",
    circleMarker: true,
    borderColor: "transparent",
    size: 3,
    id: "GroupedConnection",
    layerType: "marker",
  },
  {
    name: "Heat Pump",
    class: "heatPump",
    type: "connectionPoint",
    tool: "Marker",
    circleMarker: true,
    borderColor: "transparent",
    size: 3,
    id: "HeatPump",
    layerType: "marker",
  },
  {
    name: "Map Marker",
    class: "map-marker",
    type: "mapMarker",
    tool: "MapMarker",
    circleMarker: false,
    borderColor: "transparent",
    size: 4,
    id: "MapMarker",
    layerType: "marker",
  },
  {
    name: "Point of Connection",
    class: "point-of-connection",
    type: "connectionPoint",
    tool: "Marker",
    circleMarker: true,
    borderColor: "transparent",
    size: 3,
    id: "PointOfConnection",
    requiredFeature: "PointOfConnectionEnabled",
    layerType: "marker",
  },
  {
    name: "Sticky Note",
    class: "sticky-note",
    type: "annotation",
    tool: "Annotation",
    icon: "faStickyNote",
    circleMarker: true,
    borderColor: "transparent",
    size: 3,
    id: "Annotation",
    layerType: "marker",
    arrowSnapTarget: true,
    requiredFeature: "AnnotationToolsStickyNoteEnabled",
  },
  {
    name: "Rectangle",
    class: "rectangle",
    type: "annotation",
    tool: "Annotation",
    icon: "faSquareFull",
    id: "RectangleAnnotation",
    layerType: "polygon",
    color: "black",
    arrowSnapTarget: true,
    requiredFeature: "AnnotationToolsRectangleEnabled",
  },
  {
    name: "Circle",
    class: "circle",
    type: "annotation",
    tool: "Annotation",
    icon: "faCircle",
    id: "CircleAnnotation",
    layerType: "circle",
    color: "black",
    arrowSnapTarget: true,
    requiredFeature: "AnnotationToolsCircleEnabled",
  },
  {
    name: "Arrow",
    class: "arrow",
    type: "annotation",
    tool: "Annotation",
    icon: "faArrowRight",
    id: "ArrowAnnotation",
    layerType: "arrow",
    color: "black",
    arrowSnapTarget: false,
    requiredFeature: "AnnotationToolsArrowEnabled",
  },
];

export default function getAssetStyleInfo(className) {
  return styles.find((s) => s.class === className);
}
